module.exports = __webpack_public_path__ + "static/media/daohaus__seciton5-bg-shapes.d1cff5b6.png";